import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";

import "../assets/css/hero_section.css";

import hero1 from "../assets/images/home/hero_brass.webp";
import hero2 from "../assets/images/home/hero_brass2.webp";
import hero3 from "../assets/images/home/hero_brass3.webp";

// const heroSlides = [
//     {
//         image: hero1,
//         label: "MILAN BRASS INDUSTRIES",
//         title: "Precision Brass.",
//         highlight: "Built To Perform.",
//         description:
//             "High-quality brass components manufactured with accuracy, consistency and dependable performance for modern industrial applications.",
//         imageTag: "BRASS COMPONENTS",
//     },

//     {
//         image: hero2,
//         label: "QUALITY MANUFACTURING",
//         title: "Made With Precision.",
//         highlight: "Trusted In Industry.",
//         description:
//             "From material selection to final finishing, every component is manufactured with careful attention to quality and dimensional accuracy.",
//         imageTag: "PRECISION MANUFACTURING",
//     },

//     {
//         image: hero3,
//         label: "ENGINEERED BRASS SOLUTIONS",
//         title: "Reliable Quality.",
//         highlight: "Every Component.",
//         description:
//             "Dependable brass solutions developed for performance, durability and consistent results across diverse industrial requirements.",
//         imageTag: "QUALITY ASSURANCE",
//     },
// ];

const heroSlides = [
    {
        image: hero1,
        label: "MILAN BRASS INDUSTRIES",
        title: "Precision Brass.",
        highlight: "Built To Perform.",
        description:
            "Precision-engineered brass components manufactured for consistent quality, reliable performance and demanding industrial applications.",
        imageTag: "BRASS COMPONENTS",
    },

    {
        image: hero2,
        label: "QUALITY MANUFACTURING",
        title: "Built With Care.",
        highlight: "Made To Last.",
        description:
            "Quality brass components manufactured with accurate processes, dependable materials and attention to every production detail.",
        imageTag: "PRECISION MANUFACTURING",
    },

    {
        image: hero3,
        label: "ENGINEERED BRASS SOLUTIONS",
        title: "Reliable Brass.",
        highlight: "Every Component.",
        description:
            "Dependable brass solutions designed for durability, dimensional accuracy and consistent performance across industrial requirements.",
        imageTag: "QUALITY ASSURANCE",
    },
];

const HeroSection = () => {
    const swiperRef = useRef(null);
    const [activeSlide, setActiveSlide] = useState(0);

    const previousSlide = () => {
        swiperRef.current?.slidePrev();
    };

    const nextSlide = () => {
        swiperRef.current?.slideNext();
    };

    return (
        <section className="mbThemeHero">
            <Swiper
                modules={[Autoplay, EffectFade]}
                effect="fade"
                fadeEffect={{
                    crossFade: true,
                }}
                loop={true}
                speed={1000}
                slidesPerView={1}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
                onSlideChange={(swiper) => {
                    setActiveSlide(swiper.realIndex);
                }}
                className="mbThemeHero__swiper"
            >
                {heroSlides.map((slide, index) => (
                    <SwiperSlide key={index}>
                        <div className="mbThemeHero__slide">

                            {/* ==================================================
                  LEFT CONTENT
              ================================================== */}

                            <div className="mbThemeHero__left">

                                {/* Decorative graphics */}
                                <div
                                    className="mbThemeHero__shapes"
                                    aria-hidden="true"
                                >
                                    <span className="mbThemeHero__circle mbThemeHero__circle--large" />

                                    <span className="mbThemeHero__circle mbThemeHero__circle--small" />

                                    <span className="mbThemeHero__shapeSquare" />

                                    <span className="mbThemeHero__shapeLine" />

                                    <span className="mbThemeHero__shapeDot" />

                                    <span className="mbThemeHero__dots" />

                                    <span className="mbThemeHero__watermark">
                                        MB
                                    </span>
                                </div>


                                {/* Actual content */}
                                <div className="mbThemeHero__content">

                                    {/* Label */}
                                    <div className="mbThemeHero__label">

                                        <span className="mbThemeHero__labelIcon">
                                            <span />
                                        </span>

                                        <span className="mbThemeHero__labelText">
                                            {slide.label}
                                        </span>

                                    </div>


                                    {/* Heading */}
                                    <h1 className="mbThemeHero__heading">

                                        <span>
                                            {slide.title}
                                        </span>

                                        <strong>
                                            {slide.highlight}
                                        </strong>

                                    </h1>


                                    {/* Small accent */}
                                    <div className="mbThemeHero__headingAccent">
                                        <span />
                                        <span />
                                    </div>


                                    {/* Description */}
                                    <div className="mbThemeHero__descriptionWrap">

                                        <span className="mbThemeHero__descriptionLine" />

                                        <p>
                                            {slide.description}
                                        </p>

                                    </div>


                                    {/* Buttons */}
                                    <div className="mbThemeHero__actions">

                                        {/* <a
                                            href="/gallery"
                                            className="mbThemeHero__primaryBtn"
                                        >
                                            <span>
                                                Explore Products
                                            </span>

                                            <span className="mbThemeHero__primaryArrow">
                                                →
                                            </span>
                                        </a> */}
                                        <Link
                                            to="/gallery"
                                            className="mbThemeHero__primaryBtn"
                                        >
                                            <span>
                                                Explore Products
                                            </span>

                                            <span className="mbThemeHero__primaryArrow">
                                                →
                                            </span>
                                        </Link>


                                        {/* <a
                                            href="/contact"
                                            className="mbThemeHero__secondaryBtn"
                                        >
                                            <span>
                                                Get In Touch
                                            </span>

                                            <span className="mbThemeHero__secondaryArrow">
                                                ↗
                                            </span>
                                        </a> */}

                                    </div>


                                    {/* Bottom details */}
                                    <div className="mbThemeHero__features">

                                        <div className="mbThemeHero__feature">

                                            <span className="mbThemeHero__featureNumber">
                                                01
                                            </span>

                                            <div>
                                                <strong>
                                                    Customized
                                                </strong>

                                                <small>
                                                    Products
                                                </small>
                                            </div>

                                        </div>


                                        <div className="mbThemeHero__feature">

                                            <span className="mbThemeHero__featureNumber">
                                                02
                                            </span>

                                            <div>
                                                <strong>
                                                    Quality
                                                </strong>

                                                <small>
                                                    Assurance
                                                </small>
                                            </div>

                                        </div>


                                        <div className="mbThemeHero__feature">

                                            <span className="mbThemeHero__featureNumber">
                                                03
                                            </span>

                                            <div>
                                                <strong>
                                                    Modern
                                                </strong>

                                                <small>
                                                    Infrastructure
                                                </small>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>


                            {/* ==================================================
                  RIGHT IMAGE
              ================================================== */}

                            <div className="mbThemeHero__visual">

                                <img
                                    src={slide.image}
                                    alt="Milan Brass precision brass components"
                                    className="mbThemeHero__image"
                                />

                                <div className="mbThemeHero__imageOverlay" />

                                {/* Vertical cyan line */}
                                <span className="mbThemeHero__visualLine" />


                                {/* Bottom image tag */}
                                <div className="mbThemeHero__imageInfo">

                                    <span className="mbThemeHero__imageInfoNumber">
                                        0{index + 1}
                                    </span>

                                    <span className="mbThemeHero__imageInfoLine" />

                                    <span>
                                        {slide.imageTag}
                                    </span>

                                </div>


                                {/* Corner decoration */}
                                <div className="mbThemeHero__corner">
                                    <span />
                                </div>

                            </div>

                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>


            {/* ==================================================
          SLIDER NAVIGATION
      ================================================== */}

            <div className="mbThemeHero__navigation">

                <button
                    type="button"
                    onClick={previousSlide}
                    aria-label="Previous slide"
                    className="mbThemeHero__navBtn"
                >
                    ←
                </button>


                <div className="mbThemeHero__progress">

                    <strong>
                        0{activeSlide + 1}
                    </strong>

                    <div className="mbThemeHero__progressTrack">

                        <span
                            style={{
                                width: `${((activeSlide + 1) /
                                    heroSlides.length) *
                                    100
                                    }%`,
                            }}
                        />

                    </div>

                    <small>
                        0{heroSlides.length}
                    </small>

                </div>


                <button
                    type="button"
                    onClick={nextSlide}
                    aria-label="Next slide"
                    className="mbThemeHero__navBtn"
                >
                    →
                </button>

            </div>


            {/* ==================================================
          SIDE TEXT
      ================================================== */}

            <div className="mbThemeHero__sideText">
                <span>MILAN BRASS</span>
            </div>

        </section>
    );
};

export default HeroSection;